import { Box, Card, CardRootProps, chakra, Circle, Icon } from '@chakra-ui/react';
import { ComponentProps, PropsWithChildren } from 'react';
import { FiArrowUpRight } from 'react-icons/fi';
import { SmartLink } from './smart-link';

const ChakraLink = chakra(SmartLink);

export const HoverCardWithLink = ({
  children,
  href,
  cardRootStyles,
  showHoverIcon = true,
  linkProps,
  disabled = false,
}: PropsWithChildren & {
  href: string | null | undefined;
  cardRootStyles?: CardRootProps;
  showHoverIcon?: boolean;
  linkProps?: ComponentProps<typeof Box>;
  disabled?: boolean;
}) => {
  return (
    <ChakraLink href={href} {...linkProps}>
      <Card.Root
        borderRadius="3xl"
        overflow="hidden"
        position="relative"
        className="group" // 👈 this enables :hover targeting
        _hover={{ transform: 'scale(0.985)', transition: 'transform 0.3s' }}
        pointerEvents={disabled ? 'none' : 'auto'}
        {...cardRootStyles}
      >
        {/* Hover icon in top-right */}
        {href?.startsWith('http') && showHoverIcon && (
          <Circle
            position="absolute"
            top={4}
            right={4}
            size={6}
            bg="white"
            color="gray.600"
            opacity={0}
            _groupHover={{ opacity: 1 }}
            transition="opacity 0.2s"
            zIndex={2}
          >
            <Icon as={FiArrowUpRight} boxSize={4} />
          </Circle>
        )}
        {children}
      </Card.Root>
    </ChakraLink>
  );
};
